<template>
    <!-- Contenedor principal -->
    <v-container>
        <!-- Breadcrumbs -->
        <v-breadcrumbs :items="location" large class="blue--text"></v-breadcrumbs>
        <!-- Alertas de éxito y error -->
        <v-alert :value="alertSuccess" type="success" dark icon="mdi mdi-check-circle-outline" border="left" prominent
            elevation="2" dismissible>
            Archivo cargado con éxito
        </v-alert>
        <v-alert :value="alertError" type="error" dark icon="mdi mdi-check-circle-outline" border="left" prominent
            elevation="2" dismissible>
            Error en la carga del archivo
        </v-alert>
        <!-- Tarjeta principal -->
        <v-card style="max-width: 100%; max-height: 100%">
            <!-- Barra de herramientas -->
            <v-toolbar flat color="#395384" class="white--text">
                <v-toolbar-title>Archivos</v-toolbar-title>
                <v-spacer></v-spacer>
                <!-- Selector de orden -->
                <v-select style="max-width: 250px" v-model="sortOption" :items="sortOptions" label="Ordenar por" solo
                    class="mt-7 mr-5"></v-select>
                <!-- Botones de vista -->

                <v-btn @click="toggleView">
                    <v-icon v-if="isGrid">mdi-view-list</v-icon>
                    <v-icon v-else>mdi-view-grid</v-icon>
                </v-btn>
            </v-toolbar>
            <div class="container">
                <!-- Verificar si hay archivos o si se está cargando la lista -->
                <v-col v-if="isLoadingFiles" cols="12">
                    <!-- Skeleton loader mientras se carga la lista -->
                    <v-skeleton-loader type="table" :rows="5" :loading="isLoadingFiles"></v-skeleton-loader>
                </v-col>
                <v-col v-else>
                    <div v-if="files.length === 0">
                        <!-- Mensaje si no hay archivos -->
                        <p>No hay archivos disponibles.</p>
                    </div>

                    <!-- Vista de Grid -->
                    <template v-if="isGrid">
                        <v-row>

                            <v-col v-for="file in sortedFiles" :key="file.id" cols="12" xs="12" sm="6" md="4" lg="3">
                                <v-card class="ma-2 overflow-auto" width="400px" height="400px">
                                    <v-icon style="font-size: 200px">
                                        {{ getIconForFileType(file.fileType) }}
                                    </v-icon>
                                    <v-card-title>{{ file.name }}</v-card-title>
                                    <v-card-text>
                                        <v-row align="center" class="mx-0">
                                            <div class="grey--text ms-4">
                                                <p>Tipo de archivo: {{ file.fileType }}</p>
                                                <p>Fecha de carga: Pendiente xd</p>
                                            </div>
                                        </v-row>
                                    </v-card-text>
                                    <v-divider class="mx-4"></v-divider>
                                    <v-card-actions>
                                        <v-btn color="#395384" text @click="downloadFile(file)">
                                            Ver archivo
                                        </v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-col>
                        </v-row>
                    </template>

                    <!-- Vista de List -->
                    <template v-else>
                        <v-card-title>
                            <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line
                                hide-details></v-text-field>
                        </v-card-title>
                        <v-data-table :headers="headers" :items="sortedFiles" :search="search" item-key="id">
                            <template v-slot:item="{ item }">
                                <tr>
                                    <td>
                                        <v-icon style="font-size: 24px">
                                            {{ getIconForFileType(item.fileType) }}
                                        </v-icon>
                                    </td>
                                    <td>{{ item.name }}</td>
                                    <td>{{ item.fileType }}</td>
                                    <td>Pendiente xd</td>
                                    <td>
                                        <v-btn color="#395384" text @click="downloadFile(item)">
                                            Ver archivo
                                        </v-btn>
                                    </td>
                                </tr>
                            </template>
                        </v-data-table>
                    </template>
                </v-col>

            </div>
            <br />
            <!-- Botón flotante para cargar archivos -->
            <v-btn fab color="#395384" bottom right absolute @click.stop="dialogCharge = true" class="custom-button">
                <v-icon>mdi mdi-upload</v-icon>
            </v-btn>

            <!-- Diálogo para cargar archivos -->
            <v-dialog v-model="dialogCharge" max-width="600">
                <v-card class="v-card-style">
                    <v-card-title>Cargar Archivo</v-card-title>
                    <v-card-text>
                        <v-row align="center" justify="center">
                            <v-col cols="12">
                                <!-- Área de arrastre o selección de archivos -->
                                <div class="drop-area" :class="{ 'drag-over': isDragging }"
                                    @dragover.prevent="handleDragOver" @dragleave="handleDragLeave"
                                    @drop.prevent="handleDrop">
                                    <v-col cols="12">
                                        <!-- Input de selección de archivos oculto -->
                                        <input ref="fileInput" type="file" style="display: none" @change="handleFileChange"
                                            accept="*" />
                                        <!-- Botón para seleccionar archivo -->
                                        <v-btn @click="openFilePicker">Selecciona tu archivo</v-btn>
                                    </v-col>
                                    <br />
                                    <p>O</p>
                                    <br />
                                    <div v-if="selectedFile">
                                        <!-- Mostrar el nombre del archivo seleccionado -->
                                        <p>Archivo seleccionado:</p>
                                        <div>{{ selectedFile.name }}</div>
                                    </div>
                                    <div v-else>
                                        <h2>
                                            {{
                                                isDragging
                                                ? "Arrastra aquí tu archivo"
                                                : "Suelta el archivo aquí"
                                            }}
                                        </h2>
                                    </div>
                                </div>
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <!-- Botones para cerrar y guardar -->
                        <v-btn class="ma-2 white--text" color="red accent-4" elevation="4" @click="dialogCharge = false">
                            Cerrar
                        </v-btn>
                        <v-btn class="ma-2 white--text" color="indigo darken-4" variant="flat" elevation="4"
                            @click="uploadFile()" type="submit">
                            Guardar
                        </v-btn>
                    </v-card-actions>

                    <!-- Overlay de carga -->
                    <v-overlay :value="overlay">
                        <v-progress-circular indeterminate size="64"></v-progress-circular>
                    </v-overlay>
                </v-card>
            </v-dialog>
        </v-card>
    </v-container>
</template>

<script>
import {
    ref,
    getStorage,
    uploadBytes,
    getDownloadURL,
    listAll,
} from "firebase/storage";
import { db, collection, addDoc, getDocs } from "../../firebase/index.js";

export default {
    data() {
        return {
            // Datos del componente
            dialogCharge: false,
            overlay: false,
            isDragging: false,
            selectedFile: null,
            selectedFileUrl: "",
            alertSuccess: false,
            alertError: false,
            isLoadingFiles: true,
            isGrid: true,
            location: [
                {
                    text: "Dashboard",
                    disabled: true,
                    href: "breadcrumbs_dashboard",
                },
                {
                    text: "Recursos",
                    disabled: false,
                    href: "",
                },
                {
                    text: "Archivos",
                    disabled: false,
                    href: "",
                },
            ],
            sortOption: "name",
            sortOptions: [
                { text: "Nombre (A-Z)", value: "name" },
                { text: "Fecha (nuevo a viejo)", value: "dateDesc" },
                { text: "Fecha (viejo a nuevo)", value: "dateAsc" },
            ],
            files: [],
            search: "",
            headers: [
                { text: "Icon" },
                {
                    text: "Nombre",
                    align: "start",
                    filterable: true,
                    value: "name",
                },
                { text: "Tipo de archivo", value: "filetype" },
                { text: "Fecha de carga" },
                { text: "Accion" },


            ],
        };
    },
    computed: {
        // Función computada para ordenar archivos
        sortedFiles() {
            const filesCopy = [...this.files];
            switch (this.sortOption) {
                case "name":
                    return filesCopy.sort((a, b) => a.name.localeCompare(b.name));
                case "dateDesc":
                    return filesCopy.sort((a, b) => new Date(b.date) - new Date(a.date));
                case "dateAsc":
                    return filesCopy.sort((a, b) => new Date(a.date) - new Date(b.date));
                default:
                    return filesCopy;
            }
        },
    },
    methods: {
        // tipos de vistas
        toggleView() {
            this.isGrid = !this.isGrid;
        },
        // Función para ocultar alertas después de un tiempo
        takeAction() {
            setTimeout(() => {
                this.alertSuccess = false;
                this.alertError = false;
            }, 3000);
        },
        // Obtener la lista de archivos desde Firebase Storage
        async fetchFiles() {
            const storage = getStorage();
            const storageRef = ref(storage, "archivos/");
            const filesList = await listAll(storageRef);

            const files = [];
            for (const item of filesList.items) {
                const fileName = item.name;

                const fileExtension = fileName.split(".").pop();
                files.push({ name: fileName, ref: item, fileType: fileExtension });
            }
            this.files = files;
            this.isLoadingFiles = false; // Desactivar la animación de carga cuando se cargan los archivos
        },
        // Define los iconos para tipos de archivo específicos
        getIconForFileType(fileType) {
            const fileIcons = {
                pdf: "mdi mdi-file-pdf-box",
                doc: "mdi-file-word",
                xls: "mdi-file-excel",
                jpg: "mdi-file-image",
                png: "mdi-file-image",
                txt: "mdi mdi-text-box",
                html: "mdi mdi-language-html5",
                xml: "mdi mdi-file-xml-box",
                default: "mdi-file-question", // Icono predeterminado para archivos desconocidos
            };

            // Obtén el icono correspondiente según la extensión del archivo
            return fileIcons[fileType] || fileIcons.default;
        },
        // ...
        // Descargar un archivo
        async downloadFile(selectedFile) {
            const storage = getStorage();
            const fileRef = selectedFile.ref;
            const downloadURL = await getDownloadURL(fileRef);

            const link = document.createElement("a");
            link.href = downloadURL;
            link.target = "_blank";
            link.download = selectedFile.name;
            link.click();
        },
        // Abrir el selector de archivos al hacer clic
        openFilePicker() {
            this.$refs.fileInput.click();
        },
        // Manejar el cambio de archivo seleccionado
        handleFileChange(event) {
            this.selectedFile = event.target.files[0];
            this.displaySelectedFile(this.selectedFile);
        },
        // Manejar el evento de arrastre sobre el área de soltar
        handleDragOver(event) {
            event.preventDefault();
            this.isDragging = true;
        },
        // Manejar el evento de salida del área de arrastre
        handleDragLeave(event) {
            event.preventDefault();
            this.isDragging = false;
        },
        // Manejar el evento de soltar archivo
        handleDrop(event) {
            event.preventDefault();
            this.isDragging = false;

            this.selectedFile = event.dataTransfer.files[0];
            this.displaySelectedFile(this.selectedFile);
        },
        // Mostrar información sobre el archivo seleccionado
        displaySelectedFile(selectedFile) {
            this.selectedFile = selectedFile;
            if (this.isImageType(selectedFile)) {
                this.selectedFileUrl = URL.createObjectURL(selectedFile);
            } else {
                this.selectedFileUrl = "";
            }
        },
        // Comprobar si el archivo es de tipo imagen
        isImageType(selectedFile) {
            return selectedFile.type.startsWith("image/");
        },
        // Subir un archivo a Firebase Storage
        async uploadFile() {
            this.alertSuccess = false;
            this.alertError = false;
            if (!this.selectedFile) {
                window.alert("Seleccione un archivo");
                return;
            } else {
                this.overlay = true;
            }

            const storage = getStorage();
            const storageRef = ref(storage, "archivos/" + this.selectedFile.name);

            try {
                const uploadTask = uploadBytes(storageRef, this.selectedFile);

                uploadTask
                    .then(() => {
                        this.selectedFile = null;
                        this.fetchFiles();
                        this.dialogCharge = false;

                        this.overlay = false;
                        this.takeAction();
                        this.alertSuccess = true;
                    })
                    .catch((error) => {
                        this.overlay = false;
                        this.takeAction();
                        this.alertError = true;
                        console.log("Error de carga de archivo" + error);
                        this.dialogCharge = false;
                    });
            } catch (error) {
                console.log("Error de carga de archivo" + error);
                this.overlay = false;
                this.takeAction();
                this.alertError = true;
                this.dialogCharge = false;
            }
        },
    },
    beforeDestroy() {
        if (this.selectedFileUrl) {
            URL.revokeObjectURL(this.selectedFileUrl);
            this.overlay = false;
        }
    },
    async mounted() {
        await this.fetchFiles();
        this.overlay = false;
    },
};
</script>

<style scoped>
.custom-button {
    background-color: #395384;
    color: white;
    transition: background-color 0.3s, transform 0.3s;
}

.custom-button:hover {
    background-color: #314061;
    transform: scale(1.1);
}

.custom-button:hover v-icon:first-child {
    display: none;
}

.custom-button:hover v-icon:last-child {
    display: block;
}

.drop-area {
    border: 2px dashed #ccc;
    padding: 20px;
    text-align: center;
    cursor: pointer;
}

.drag-over {
    border-color: #1976d2;
}

@media screen and (max-width: 768px) {}
</style>
